import z from "zod";
export function object(shape) {
    return z.object(shape).prefault(() => ({}));
}
export function int(min, max, default_value) {
    return z.number().int().min(min).max(max).catch(default_value);
}
export function boolean(default_value) {
    return z.boolean().catch(default_value);
}
